import { removeCacheDB } from '@/utils/revalidate_cache';

export const doLogout = async () => {
  try {
    await removeCacheDB();
  } catch (e) {
    console.warn('can not delete db', e);
  }
  try {
    // window?.localStorage?.clear();
    window?.sessionStorage?.clear();
  } catch (e) {
    console.warn('clear store error', e);
  }
  window.location.href = `/account/logout?redirect_to=${encodeURIComponent(
    window.location.href
  )}`;
};
